// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","proCon":"RentBuyDetail_proCon__I4wl6","cta":"RentBuyDetail_cta__8qKJH","video":"RentBuyDetail_video__wXN72"};